var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list"},[_c('div',{attrs:{"id":"stats"}},[_c('div',{attrs:{"id":"list_menu"}},[_c('router-link',{attrs:{"to":"/stats/"}},[_vm._v("Количество QSO из RDA")])],1),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }